<template>
  <form @submit.prevent="submitForm" class="form-group">
    <label for="login">Identifiant</label>
    <input
      id="login"
      v-model="form.login"
      type="text"
      placeholder="+237690000000"
      required
    />
    <label for="password">Mot de passe</label>
    <input
      id="password"
      v-model="form.password"
      type="password"
      placeholder="***************"
      required
    />
    <div class="btn-group">
      <button type="submit" class="btn btn-primary">S'identifier</button>
      <router-link :to="{ name: 'forgot' }" class="btn btn-secondary">Mot de passe oublié?</router-link>
    </div>
  </form>
  <LoaderOverlay v-if="loading" />
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useToast } from 'vue-toast-notification'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/userStore'
import { config } from '@/config/env.js'
import LoaderOverlay from '@/components/LoaderOverlay.vue'
import { useLocaleStore } from '@/stores/localeStore'

const success = ref(false)
const error   = ref(false)
const toast   = useToast()
const router  = useRouter()
const userStore   = useUserStore()
const localeStore = useLocaleStore()
const loading = ref(false)

const form = reactive({
  login: '',
  password: ''
})

const submitForm = async () => {
  loading.value = true
  try {
    const response = await fetch(config.apiUrl + '/user/login', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        login: form.login,
        password: form.password,
        countryIso: localeStore.countryIso
      })
    })

    const data = await response.json()

    if (response.ok) {
      toast.success('Connexion réussie !')
      await userStore.fetchUser() // ✅ whoami + setUser + setFromUser + removeItem localStorage
      router.push({ name: 'account' })
      success.value = true
      setTimeout(() => { success.value = false }, 3000)
    } else {
      toast.error(data.message ?? 'Une erreur est survenue lors de la connexion')
      error.value = true
    }
  } catch (err) {
    error.value = true
    toast.error('Une erreur est survenue lors de la connexion.')
  } finally {
    loading.value = false
    setTimeout(() => { error.value = false }, 3000)
  }
}
</script>
